module.exports = __webpack_public_path__ + "img/SemAgendamento-backup.2f5a529e.png";